export default "__VITE_ASSET__CUmoelEE__"